import IdentifiableDto from 'modules/base/dto/IdentifiableDto';

export class DataSplitTaskFieldEditDto extends IdentifiableDto {
    constructor() {
        super();

        /** @type {number} */
        this.measurementFieldName = null;
    }

    /**
     * @typedef {Object} _DataSplitTaskFieldEditDtoProps
     * @property {number} measurementFieldName
     *
     * @typedef {import("./IdentifiableDto").IdentifiableDtoProps & _DataSplitTaskFieldEditDtoProps} DataSplitTaskFieldEditDtoProps
     */
    /**
     *
     * @param {DataSplitTaskFieldEditDtoProps} props
     * @returns {DataSplitTaskFieldEditDto}
     */
    setup(props) {
        super.setup(props);

        this.measurementFieldName = props.measurementFieldName;

        return this;
    }
}

export default DataSplitTaskFieldEditDto;